export { enUS } from "date-fns/locale/en-US";
//# sourceMappingURL=locales.js.map